var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCustomModule(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_666_13891)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M19.712 19.7116C21.3277 18.096 19.1848 13.3336 14.9258 9.07454C10.6668 4.81551 5.90439 2.67264 4.28871 4.28831C2.67304 5.90398 4.81591 10.6664 9.07494 14.9254C13.334 19.1844 18.0964 21.3273 19.712 19.7116Z",
    fill: "#A461D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.712 19.7116C21.3277 18.096 19.1848 13.3336 14.9258 9.07454C10.6668 4.81551 5.90439 2.67264 4.28871 4.28831C2.67304 5.90398 4.81591 10.6664 9.07494 14.9254C13.334 19.1844 18.0964 21.3273 19.712 19.7116Z",
    stroke: "#A461D8",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9258 14.9255C19.1848 10.6664 21.3277 5.90404 19.712 4.28836C18.0964 2.67269 13.334 4.81556 9.07494 9.07459C4.81591 13.3336 2.67304 18.096 4.28871 19.7117C5.90439 21.3274 10.6668 19.1845 14.9258 14.9255Z",
    stroke: "#A461D8",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 13.125C12.6213 13.125 13.125 12.6213 13.125 12C13.125 11.3787 12.6213 10.875 12 10.875C11.3787 10.875 10.875 11.3787 10.875 12C10.875 12.6213 11.3787 13.125 12 13.125Z",
    fill: "#A461D8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_666_13891"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomModule);
export default __webpack_public_path__ + "static/media/custom-module.194cfd01c7d533593648c2c73455be88.svg";
export { ForwardRef as ReactComponent };